import { useLocation } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import "./styles/Sidebar.css";
import VariableContext from "../contexts/VariableContext";
import FetchingFreq from "../contexts/FetchingFreq";
import config from "../configs/config";

function Sidebar() {
  const location = useLocation();
  const [contextMenu, setContextMenu] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");


  const {
    sdataGroup,
    dataGroup,
    projectId,
    setcurrentSelectedVariablesset,
    currentSelectedVariablesset,
    currentSelectedVariables,
    setCurrentSelectedVariables,
    setSdataGroup,
    setdataGroup,
    registerDndHandler,
    selectedProjectDetails,
    setSelectedProjectDetails,
    setSelectedClient,
    setSelectedProject,
    setPID,
    setPName,
    setBanners,
    setSavedWeightings,
    setWeightingStats,
    setPowner,
  } = useContext(VariableContext);

  const {
    handleSelectionChange,
    activePage,
    handleTitleClick,
    isModalOpen,
    addQuestion,
    rows,
    setRows,
    setColumns,
    statements,
    setStatements,
    setIsModalOpen,
    setSelectedTitle,
    setSelectedVariable,
    handleDVValidation,
    oeParameters,
    setOeParameters,
    selectedQuestionKey,
    setSelectedQuestionKey,
  } = useContext(FetchingFreq);

  // Close context menu when clicking outside
  useEffect(() => {
    const handleClickOutside = () => setContextMenu(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const loadAllData = async () => {
      if (!projectId) return;

      console.log("📥 Sidebar: Loading data for project", projectId);

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/get-survey/${projectId}`
        );

        if (response.ok) {
          const data = await response.json();

          // Load survey data (for SurveyBuilder)
          if (data.sqgroup && Object.keys(data.sqgroup).length > 0) {
            setSdataGroup(data.sqgroup);
            console.log("✅ Sidebar: Loaded sdataGroup");
          }

          // Load table data (for DataTables, Weighting, etc.)
          if (data.qgroup && Object.keys(data.qgroup).length > 0) {
            setdataGroup(data.qgroup);
            console.log("✅ Sidebar: Loaded dataGroup");
          }

          // Cache in localStorage as backup
          if (data.sqgroup) {
            localStorage.removeItem("sdataGroup");
            localStorage.setItem(
              "sdataGroup",
              JSON.stringify(data.sqgroup)
            );
          }
          if (data.qgroup) {
            localStorage.removeItem("dataGroup");
            localStorage.setItem(
              "dataGroup",
              JSON.stringify(data.qgroup)
            );
          }
        }
      } catch (error) {
        console.error("❌ Sidebar: Error loading data", error);

        // Fallback to localStorage
        const cachedSd = localStorage.getItem("sdataGroup");
        const cachedD = localStorage.getItem("dataGroup");

        if (cachedSd) setSdataGroup(JSON.parse(cachedSd));
        if (cachedD) setdataGroup(JSON.parse(cachedD));
      }

      // `/get-survey` only carries qgroup/sqgroup. Banners, weighting and the
      // client/project/pid/pname/owner details live elsewhere and aren't
      // persisted to localStorage, so a hard refresh on any non-Home route
      // loses them until the user reopens the project from Home. Restore
      // them here too, since Sidebar mounts on every route.
      if (selectedProjectDetails) return; // already loaded (e.g. via Home's project picker)

      try {
        const filesResponse = await fetch(
          `${config.API_BASE_URL}/project/${projectId}/files`
        );
        if (!filesResponse.ok) return;

        const files = await filesResponse.json();
        const fileData = files[0];
        if (!fileData) return;

        setSelectedClient(fileData.client);
        setSelectedProject(fileData.project);
        setPID(fileData.pid || null);
        setPName(fileData.pname || null);
        setPowner(fileData.owner || "");
        setSelectedProjectDetails(fileData);
        setBanners(fileData.banner_data || []);
        setSavedWeightings(fileData.weighting);
        if (fileData.weighting) {
          setWeightingStats({ ...fileData.weighting?.weight?.stats });
          setcurrentSelectedVariablesset(
            Object.keys(fileData.weighting?.weight?.weightedCounts || {})
          );
        }
        console.log("✅ Sidebar: Restored project details/banners/weighting");
      } catch (error) {
        console.error("❌ Sidebar: Error restoring project details", error);
      }
    };

    loadAllData();
  }, [projectId]); // Run when projectId changes

useEffect(() => {
  const isSurveyBuilder = location.pathname === "/surveybuilder";
  const sourceData = isSurveyBuilder ? sdataGroup : dataGroup;
  if (!sourceData) return;

  // SurveyBuilder (sdataGroup) orders by _order; the regular dataGroup
  // (Tables/Weighting/Banner/etc.) orders by `order`, matching Home.js,
  // DataTables.js and the backend export sort.
  const orderKey = isSurveyBuilder ? "_order" : "order";

  let changed = false;
  const updatedData = {};

  Object.entries(sourceData).forEach(([key, value], index) => {
    if (!value || value[orderKey] === undefined) {
      changed = true;
      updatedData[key] = { ...value, [orderKey]: index };
    } else {
      updatedData[key] = value;
    }
  });

  if (!changed) return; // 🔑 critical

  if (isSurveyBuilder) {
    setSdataGroup(updatedData);
  } else {
    setdataGroup(updatedData);
  }
}, [location.pathname]); // 👈 REMOVE dataGroup deps

  // useEffect(() => {
  //   // Register handler for App.js to call (via Context)
  //   registerDndHandler("sidebar", handleDragEnd);
  //   return () => {
  //     registerDndHandler("sidebar", null);
  //   };
  // }, [sdataGroup, dataGroup, location.pathname, registerDndHandler]);
useEffect(() => {
  registerDndHandler("sidebar", handleDragEnd);
  return () => registerDndHandler("sidebar", null);
}, []);
  // Add this new useEffect
  useEffect(() => {
    // Auto-scroll to selected question when it changes
    if (selectedQuestionKey) {
      const element = document.querySelector(
        `[data-question-key="${selectedQuestionKey}"]`
      );
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }
    }
  }, [selectedQuestionKey]);

  const handleContextMenu = (e, title, qgroupEntry) => {
    e.preventDefault();
    setContextMenu({
      x: e.clientX,
      y: e.clientY,
      title,
      qgroupEntry,
    });
  };

  const handleDuplicate = () => {
    if (!contextMenu) return;

    const { title, qgroupEntry } = contextMenu;
    const isSurveyBuilder = location.pathname === "/surveybuilder";
    const sourceData = isSurveyBuilder ? sdataGroup : dataGroup;
    const orderKey = isSurveyBuilder ? "_order" : "order";

    // Create new key with _dup suffix
    const newKey = `${title}_dup`;

    // Check if duplicate already exists, if so add a number
    let finalKey = newKey;
    let counter = 1;
    while (sourceData[finalKey]) {
      finalKey = `${newKey}${counter}`;
      counter++;
    }

    // Get all sorted entries (filter null/undefined values first to avoid sort errors)
    const sortedEntries = Object.entries(sourceData)
      .filter(([_, v]) => v != null)
      .sort((a, b) => {
        const orderA = a[1][orderKey] !== undefined ? a[1][orderKey] : 0;
        const orderB = b[1][orderKey] !== undefined ? b[1][orderKey] : 0;
        return orderA - orderB;
      });

    // Filter out removed tabs to get visible entries
    const visibleEntries = isSurveyBuilder
      ? sortedEntries.filter(([_, qgroupEntry]) => !qgroupEntry.removeTab)
      : sortedEntries;

    // Find the position of the selected question
    const selectedIndex = visibleEntries.findIndex(([key, _]) => key === title);
    const insertPosition =
      selectedIndex !== -1 ? selectedIndex + 1 : visibleEntries.length;

    // Create duplicate with all properties
    const duplicatedEntry = {
      ...qgroupEntry,
      [orderKey]: insertPosition,
      newkey: title,
      // Update Question_number if it exists
      ...(qgroupEntry.Question_number && {
        Question_number: `${qgroupEntry.Question_number}_dup${counter > 1 ? counter - 1 : ""
          }`,
      }),
    };

    // Create new data structure with updated orders
    const updatedData = {};

    // Add entries before the insert position with their current order
    visibleEntries.slice(0, insertPosition).forEach(([key, value], index) => {
      updatedData[key] = { ...value, [orderKey]: index };
    });

    // Add the duplicated question at the insert position
    updatedData[finalKey] = duplicatedEntry;

    // Add entries after the insert position with incremented order
    visibleEntries.slice(insertPosition).forEach(([key, value], index) => {
      updatedData[key] = { ...value, [orderKey]: insertPosition + 1 + index };
    });

    // Add back any removed entries at the end (for survey builder)
    if (isSurveyBuilder) {
      const removedEntries = sortedEntries.filter(
        ([_, qgroupEntry]) => qgroupEntry.removeTab
      );
      removedEntries.forEach(([key, value], index) => {
        updatedData[key] = {
          ...value,
          [orderKey]: visibleEntries.length + 1 + index,
        };
      });
    }

    if (isSurveyBuilder) {
      setSdataGroup(updatedData);
    } else {
      setdataGroup(updatedData);
    }

    setContextMenu(null);
  };

  const onTitleClick = async (title, qgroupEntry) => {
    // Track the selected question
    setSelectedQuestionKey(title);

    if (activePage == "Weighting") {
      const selection = [
        ...currentSelectedVariablesset,
        ...qgroupEntry.varName.map((x) => x.Name),
      ];
      setcurrentSelectedVariablesset(selection);
      if (!currentSelectedVariables.includes(title)) {
        setCurrentSelectedVariables((prev) => [...prev, title]);
      }
    } else if (activePage == "Banner") {
      handleSelectionChange(title, qgroupEntry);
    } else if (activePage == "dashboard") {
      setSelectedVariable(qgroupEntry);
    } else if (activePage == "crosstab") {
      setSelectedVariable(qgroupEntry);
    } else if (activePage == "tables") {
      handleTitleClick(title);
    } else if (activePage == "analysis") {
      const selection = [
        ...currentSelectedVariablesset,
        ...qgroupEntry.varName.map((x) => x.Name),
      ];
      setcurrentSelectedVariablesset(selection);
    } else if (activePage == "survey") {
      setSelectedVariable(qgroupEntry);
      setRows(qgroupEntry.rows);
      setColumns(qgroupEntry.columns);
      setStatements(qgroupEntry.statements);
      setOeParameters(qgroupEntry.oeparameters || {});
      setSelectedTitle(title);
    } else if (activePage == "dv") {
      handleDVValidation(title);
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    console.log(
      "Drag started from:",
      result.source.index,
      "to:",
      result.destination.index
    );

    const isSurveyBuilder = location.pathname === "/surveybuilder";
    const sourceData = isSurveyBuilder ? sdataGroup : dataGroup;
    const orderKey = isSurveyBuilder ? "_order" : "order";

    if (!sourceData) {
      console.log("No source data available");
      return;
    }

    // Convert object to array and sort by current order
    const allEntries = Object.entries(sourceData).sort((a, b) => {
      const orderA = a[1][orderKey] !== undefined ? a[1][orderKey] : 0;
      const orderB = b[1][orderKey] !== undefined ? b[1][orderKey] : 0;
      return orderA - orderB;
    });

    // Filter out removed tabs if in survey builder to get the visible list
    const visibleEntries = isSurveyBuilder
      ? allEntries.filter(([_, qgroupEntry]) => !qgroupEntry.removeTab)
      : allEntries;

    console.log(
      "Before reorder:",
      visibleEntries.map(([key, val]) => ({ key, order: val[orderKey] }))
    );

    // Perform the reorder on visible entries
    const [movedItem] = visibleEntries.splice(result.source.index, 1);
    visibleEntries.splice(result.destination.index, 0, movedItem);

    // Update order property for ALL entries (both visible and removed)
    const reorderedData = {};

    // First, add all visible entries with updated order
    visibleEntries.forEach(([key, value], index) => {
      reorderedData[key] = { ...value, [orderKey]: index };
    });

    // Then add removed entries (if any) with order after visible ones
    if (isSurveyBuilder) {
      const removedEntries = allEntries.filter(
        ([_, qgroupEntry]) => qgroupEntry.removeTab
      );
      removedEntries.forEach(([key, value], index) => {
        reorderedData[key] = {
          ...value,
          [orderKey]: visibleEntries.length + index,
        };
      });
    }

    console.log(
      "After reorder:",
      Object.entries(reorderedData).map(([key, val]) => ({
        key,
        order: val[orderKey],
      }))
    );

    // Update the appropriate context
    if (isSurveyBuilder) {
      setSdataGroup(reorderedData);
    } else {
      setdataGroup(reorderedData);
    }
  };

  const renderQGroupTitles = () => {
    const isSurveyBuilder = location.pathname === "/surveybuilder";

    if (isSurveyBuilder && sdataGroup) {
      // Sort all entries by _order first
      const sortedEntries = Object.entries(sdataGroup).sort((a, b) => {
const orderA = a[1]?._order !== undefined ? a[1]._order : Infinity;
const orderB = b[1]?._order !== undefined ? b[1]._order : Infinity;
        return orderA - orderB;
      });

      const orderedKeys = sortedEntries
        .filter(([_, q]) => !q.removeTab)
        .map(([key]) => key);
      // Then filter out removed tabs
      const filteredEntries = sortedEntries.filter(
        ([_, qgroupEntry]) => qgroupEntry && !qgroupEntry.removeTab
      );

      return (
        <Droppable droppableId="sidebar-questions">
          {(provided) => (
            <ul
              className="custom-list"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {filteredEntries.map(([title, qgroupEntry], index) => (
                <Draggable
                  key={title}
                  draggableId={`sidebar-${title}`}
                  index={orderedKeys.indexOf(title)}
                >
                  {(provided, snapshot) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      data-question-key={title}
                      title={qgroupEntry["Question_number"] || title}
                      className={`custom-list-item ${snapshot.isDragging ? "dragging" : ""
                        } ${selectedQuestionKey === title
                          ? "selected-question"
                          : ""
                        }`}
                      style={{
                        ...provided.draggableProps.style,
                      }}
                      onClick={() => onTitleClick(title, qgroupEntry)}
                      onContextMenu={(e) =>
                        handleContextMenu(e, title, qgroupEntry)
                      }
                    >
                      {qgroupEntry["Question_number"] || title}
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      );
    }

    if (dataGroup) {
      // Sort entries by order
      const entries = Object.entries(dataGroup).sort((a, b) => {
        const orderA = a[1]?.order !== undefined ? a[1]?.order : Infinity;
        const orderB = b[1]?.order !== undefined ? b[1]?.order : Infinity;
        return orderA - orderB;
      });
      const orderedKeys = entries.map(([key]) => key);

      return (
        <Droppable droppableId="sidebar-questions">
          {(provided) => (
            <ul
              className="custom-list"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {entries
                .filter(([title, qgroupEntry]) => {
                  if (!qgroupEntry) return false; // ← add this line
                  if (!searchTerm) return true;
                  const label = qgroupEntry.title || title;
                  return label.toLowerCase().includes(searchTerm.toLowerCase());
                })
                .map(([title, qgroupEntry], index) => (

                  <Draggable
                    key={title}
                    draggableId={`sidebar-${title}`}
                    index={orderedKeys.indexOf(title)}
                  >
                    {(provided, snapshot) => (
                      <li
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        title={qgroupEntry.title || title}
                        className={`custom-list-item ${snapshot.isDragging ? "dragging" : ""
                          } ${selectedQuestionKey === title
                            ? "selected-question"
                            : ""
                          }`}
                        style={{
                          ...provided.draggableProps.style,
                        }}
                        onClick={() => onTitleClick(title, qgroupEntry)}
                        onContextMenu={(e) =>
                          handleContextMenu(e, title, qgroupEntry)
                        }
                      >
                        {qgroupEntry.title || title}
                      </li>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      );
    }

    return null;
  };

  const toggleModal = () => {
    // Pass the selected question key to addQuestion
    addQuestion(selectedQuestionKey);
    setIsModalOpen((prev) => !prev);
  };

  return (
    <div className="custom-scrollbar">
      {activePage == "survey" && (
        <button onClick={() => toggleModal()} className="add-question-btn">
          Add Question
        </button>
      )}
      <input
        type="text"
        placeholder="Search variables..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="sidebar-search-input"
      />
      <div className="custom-scrollbar-inner">{renderQGroupTitles()}</div>
      {isModalOpen}

      {/* Context Menu */}
      {contextMenu && (
        <div
          className="sidebar-context-menu"
          style={{ top: contextMenu.y, left: contextMenu.x }}
        >
          <div className="sidebar-context-menu-item" onClick={handleDuplicate}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
            Duplicate
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
